import NewsletterCTA from "../components/NewsletterCTA";

export default function Partners() {
  return (
    <main className="max-w-3xl mx-auto px-4 py-12">
      <h1 className="text-3xl md:text-4xl font-extrabold text-[#0A2540]">
        Partners
      </h1>
      <p className="mt-3 text-slate-700">
        We collaborate with nationally recognized law firms and litigation
        partners. For partnership inquiries, contact{" "}
        <a className="underline" href="mailto:info@masstortplaintiffs.com">
          info@masstortplaintiffs.com
        </a>
        .
      </p>
      <NewsletterCTA />
    </main>
  );
}
